module.exports = __webpack_public_path__ + "static/img/znsj-bg.9766d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/znsj-bg.png
// module id = NC43
// module chunks = 96